export interface AnimeItem {
  id: string;
  title: string;
  genre: string;
  status: string;
  episodes: string;
  score: string;
  year: number;
  poster: string;
  summary: string;
  highlight: string;
  weeklyRank?: number;
  heat?: number;
  isNew?: boolean;
  isPick?: boolean;
  isClassic?: boolean;
  classicNote?: string;
}

export const animeGenres = [
  '全部',
  '热血战斗',
  '科幻机甲',
  '奇幻冒险',
  '悬疑推理',
  '日常治愈',
  '校园青春',
];

export const animeLibrary: AnimeItem[] = [
  {
    id: 'star-echo',
    title: '星轨残响',
    genre: '科幻机甲',
    status: '更新中',
    episodes: '更新至 19 话',
    score: '9.6',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20young%20pilot%20standing%20before%20a%20glowing%20starship%2C%20star%20trails%20and%20nebula%20in%20deep%20space%2C%20coral%20and%20amber%20accent%20colors%2C%20cel%20shaded%20illustration%2C%20dramatic%20rim%20lighting%2C%20clean%20simple%20composition%2C%20high%20detail&width=600&height=840&seq=anime-poster-01&orientation=portrait',
    summary:
      '一艘失联十年的勘探舰突然返回轨道，年轻飞行员与沉默的导航 AI 必须在天亮之前查明舰上到底发生了什么。',
    highlight: '第 19 话的长镜头空战被不少观众反复回看。',
    weeklyRank: 1,
    heat: 98,
    isPick: true,
  },
  {
    id: 'white-blade',
    title: '白刃夜行',
    genre: '热血战斗',
    status: '更新中',
    episodes: '更新至 12 话',
    score: '9.3',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20swordsman%20in%20flowing%20dark%20robe%20under%20a%20moonlit%20sky%2C%20glowing%20blade%2C%20warm%20orange%20embers%2C%20dramatic%20action%20pose%2C%20cel%20shaded%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=840&seq=anime-poster-02&orientation=portrait',
    summary:
      '背负旧债的剑客在边境小城落脚，本想收刀，却因一场雨夜冲突重新被卷入江湖的连锁恩怨。',
    highlight: '打斗的分镜节奏干脆，单集信息量很足。',
    weeklyRank: 2,
    heat: 95,
  },
  {
    id: 'deep-echo',
    title: '深海回声',
    genre: '悬疑推理',
    status: '完结',
    episodes: '全 24 话',
    score: '9.1',
    year: 2024,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20detective%20gazing%20at%20a%20rainy%20harbor%20at%20night%2C%20mysterious%20mood%2C%20teal%20and%20amber%20streetlights%2C%20cinematic%20composition%2C%20cel%20shaded%20illustration%2C%20simple%20background&width=600&height=840&seq=anime-poster-03&orientation=portrait',
    summary:
      '港口城市接连出现无人认领的录音带，一位习惯独自查案的侦探发现每盘磁带都指向同一个失踪的夜晚。',
    highlight: '结局把前 20 话的伏笔收得比较完整，适合一口气补。',
    weeklyRank: 3,
    heat: 91,
  },
  {
    id: 'sword-song',
    title: '剑舞长歌',
    genre: '奇幻冒险',
    status: '完结',
    episodes: '全 36 话',
    score: '9.0',
    year: 2023,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20an%20ancient%20warrior%20with%20a%20long%20sword%20before%20misty%20mountains%2C%20ink%20wash%20and%20warm%20gold%20tones%2C%20epic%20fantasy%20mood%2C%20cel%20shaded%20art%2C%20clean%20background%2C%20high%20detail&width=600&height=840&seq=anime-poster-04&orientation=portrait',
    summary:
      '少年为寻回被夺走的名剑踏上长途，一路结识各怀心事的同行者，也逐步看清江湖旧秩序的裂缝。',
    highlight: '世界观铺陈从容，中段的群像戏口碑较好。',
    weeklyRank: 4,
    heat: 88,
    isClassic: true,
    classicNote:
      '长篇群像改编里少见的耐心之作：前三话先把人物关系与地理版图交代清楚，再逐步进入主线。它的战斗设计强调地形与兵器的配合，而非单纯堆叠招式。如果你更在意故事的完整度与收束感，这部适合按顺序一次性看完。',
  },
  {
    id: 'spring-bakery',
    title: '春日烘焙屋',
    genre: '日常治愈',
    status: '更新中',
    episodes: '更新至 8 话',
    score: '8.9',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20cozy%20bakery%20storefront%20with%20fresh%20bread%20and%20flowers%2C%20warm%20cream%20and%20peach%20colors%2C%20soft%20sunlight%2C%20gentle%20slice%20of%20life%20mood%2C%20cel%20shaded%20illustration%2C%20simple%20background&width=600&height=840&seq=anime-poster-05&orientation=portrait',
    summary:
      '接手外婆旧店面的年轻人，用每日限量的面包慢慢重新认识这条街，也认识留下来的老邻居们。',
    highlight: '适合睡前一集一节，节奏舒缓不催人。',
    weeklyRank: 5,
    heat: 84,
  },
  {
    id: 'mecha-dawn',
    title: '机械纪元：黎明',
    genre: '科幻机甲',
    status: '完结',
    episodes: '全 26 话',
    score: '8.8',
    year: 2022,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20giant%20mecha%20rising%20over%20a%20city%20at%20dawn%2C%20orange%20and%20gold%20sky%2C%20epic%20scale%2C%20cel%20shaded%20illustration%2C%20dramatic%20lighting%2C%20clean%20composition%2C%20high%20detail&width=600&height=840&seq=anime-poster-06&orientation=portrait',
    summary:
      '停战协定签署后的第十年，一名维修技师在废料场重启了被封存的原型机体，也重启了旧时代的对立。',
    highlight: '机设细节讲究，机体维护与检修的描写很扎实。',
    weeklyRank: 6,
    heat: 79,
    isClassic: true,
    classicNote:
      '这部作品的看点不在“打得多”，而在“修得多”：大量篇幅描写机体的维护、燃料与补给，让战斗有了成本与重量。配角线写得完整，几场对手戏的情绪落点很稳。若你喜欢偏写实向的机甲设定，可以把它当成一份入门参考。',
  },
  {
    id: 'time-postman',
    title: '时之邮差',
    genre: '奇幻冒险',
    status: '新番',
    episodes: '更新至 4 话',
    score: '8.7',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20traveler%20with%20a%20glowing%20mailbag%20walking%20through%20a%20magical%20forest%20portal%2C%20warm%20amber%20light%2C%20fantasy%20adventure%20mood%2C%20cel%20shaded%20art%2C%20simple%20background&width=600&height=840&seq=anime-poster-07&orientation=portrait',
    summary:
      '一名负责投递“来不及寄出的信”的邮差，穿梭在不同时间线的城镇之间，把话送到该送到的人手里。',
    highlight: '单元剧结构，每集一个独立情感落点。',
    isNew: true,
  },
  {
    id: 'cat-spirit',
    title: '屋檐下的猫又',
    genre: '日常治愈',
    status: '新番',
    episodes: '更新至 5 话',
    score: '8.6',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20fluffy%20cat%20spirit%20resting%20on%20a%20sunlit%20wooden%20porch%2C%20warm%20neutral%20tones%2C%20cozy%20gentle%20atmosphere%2C%20cel%20shaded%20illustration%2C%20clean%20simple%20background&width=600&height=840&seq=anime-poster-08&orientation=portrait',
    summary:
      '搬进老宅的姐妹俩发现屋顶住着一只能听懂人话的猫又，日常的麻烦事从此有了个毛茸茸的“顾问”。',
    highlight: '画风柔和，配乐与节奏都很放松。',
    isNew: true,
  },
  {
    id: 'ghost-detective',
    title: '灵域侦探社',
    genre: '悬疑推理',
    status: '新番',
    episodes: '更新至 6 话',
    score: '8.5',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20young%20detective%20holding%20a%20lantern%20in%20a%20haunted%20old%20library%2C%20eerie%20warm%20candlelight%2C%20mystery%20mood%2C%20cel%20shaded%20art%2C%20simple%20background%2C%20high%20detail&width=600&height=840&seq=anime-poster-09&orientation=portrait',
    summary:
      '一所只在深夜开放的“侦探社”，专门受理那些没法用常理解释的委托，案子背后往往藏着一段旧人情。',
    highlight: '谜面设计偏巧，线索给得比较公平。',
    isNew: true,
  },
  {
    id: 'fireworks-club',
    title: '花火研究部',
    genre: '校园青春',
    status: '新番',
    episodes: '更新至 7 话',
    score: '8.4',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20group%20of%20cheerful%20students%20under%20golden%20fireworks%20at%20a%20summer%20festival%2C%20warm%20orange%20and%20pink%20sky%2C%20youthful%20energetic%20mood%2C%20cel%20shaded%20illustration%2C%20simple%20background&width=600&height=840&seq=anime-poster-10&orientation=portrait',
    summary:
      '为了在校庆上放一场自己做的烟花，几个“不太合群”的同学凑成一个社团，从零开始学配方和搭建。',
    highlight: '群像塑造轻松，台词节奏明快。',
    isNew: true,
  },
  {
    id: 'kite-wind',
    title: '纸鸢与风',
    genre: '校园青春',
    status: '完结',
    episodes: '全 12 话',
    score: '8.8',
    year: 2024,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20girl%20flying%20a%20kite%20on%20a%20grassy%20hill%20at%20golden%20hour%2C%20soft%20amber%20light%2C%20nostalgic%20coming%20of%20age%20mood%2C%20cel%20shaded%20art%2C%20clean%20simple%20background&width=600&height=840&seq=anime-poster-11&orientation=portrait',
    summary:
      '小城的夏天很长，放风筝的社团把几个原本不熟的同学变成朋友，也留下一段说不出口的告别。',
    highlight: '12 集短篇，适合一个下午看完。',
    isPick: true,
  },
  {
    id: 'cicada-summer',
    title: '蝉鸣时节',
    genre: '校园青春',
    status: '完结',
    episodes: '全 13 话',
    score: '8.9',
    year: 2021,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20two%20friends%20standing%20on%20a%20riverside%20path%20in%20summer%20twilight%2C%20warm%20dusk%20colors%2C%20emotional%20bittersweet%20mood%2C%20cel%20shaded%20illustration%2C%20simple%20background&width=600&height=840&seq=anime-poster-12&orientation=portrait',
    summary:
      '毕业前的最后一个夏天，两个曾经形影不离的朋友在河堤上重新说起当年的那件事。',
    highlight: '情绪克制，结尾留白处理得干净。',
    isClassic: true,
    classicNote:
      '它把“告别”拆成许多很小的瞬间：一次借伞、一段没发出去的消息、一场没能一起看的烟火。全篇没有刻意的煽情桥段，却靠细节慢慢累积情绪。13 集长度刚好，推荐在安静的晚上连着看完。',
  },
  {
    id: 'galaxy-train',
    title: '银河列车之夜',
    genre: '科幻机甲',
    status: '完结',
    episodes: '全 18 话',
    score: '8.7',
    year: 2023,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20streamlined%20train%20gliding%20through%20a%20starry%20galaxy%2C%20warm%20amber%20and%20gold%20stars%2C%20dreamy%20sci%20fi%20mood%2C%20cel%20shaded%20art%2C%20clean%20simple%20background&width=600&height=840&seq=anime-poster-13&orientation=portrait',
    summary:
      '一趟只在校历最后一夜发车的列车，载着乘客穿过一个个星球站台，每一站都有人上、有人下。',
    highlight: '美术与配乐是这个系列最大的亮点。',
    isClassic: true,
    classicNote:
      '更像一本会动的画集：每到一个星球站台，画面风格就换一次。它的叙事偏散文，主线很轻，重心放在“路过”与“告别”的意象上。如果你喜欢氛围和视觉呈现胜过强情节，这部值得补。',
  },
  {
    id: 'midnight-diner',
    title: '零点食肆',
    genre: '日常治愈',
    status: '更新中',
    episodes: '更新至 10 话',
    score: '8.6',
    year: 2025,
    poster:
      'https://readdy.ai/api/search-image?query=anime%20style%20poster%20of%20a%20cozy%20night%20diner%20serving%20hot%20noodles%2C%20warm%20lantern%20glow%2C%20urban%20food%20theme%2C%20cel%20shaded%20illustration%2C%20simple%20background%2C%20high%20detail&width=600&height=840&seq=anime-poster-14&orientation=portrait',
    summary:
      '只在零点后开门的小店，每集招待一位深夜来客，一道家常菜配一段各自的人生片段。',
    highlight: '美食作画精细，故事短而不散。',
    isPick: true,
  },
];

export const animeGuideSteps = [
  {
    icon: 'ri-search-2-line',
    title: '第一步：先定作品',
    text: '在“作品速查库”里按类型筛选，或直接输入关键词，先锁定你想看的那一部。全集与更新中的状态会标在卡片上。',
  },
  {
    icon: 'ri-list-check-2',
    title: '第二步：看榜单选片',
    text: '如果没有明确目标，从“本周热播榜”入手最省事。榜单按近期讨论热度排序，并标出近期看点，避免踩到节奏太慢的开局。',
  },
  {
    icon: 'ri-calendar-line',
    title: '第三步：跟着新番追',
    text: '“新番导视”列出当季开播的作品与更新进度。挑两三部同步追即可，其余适合等完结后再一口气补完。',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '第四步：留好待看清单',
    text: '把“编辑精选”和“完结神作”当作长期清单。完结作品不用担心断更，适合周末整块时间集中观看。',
  },
];

export const animeFaqs = [
  {
    q: '这个页面主要整理了什么？',
    a: '页面把作品本身、类型分类与更新状态集中在一处：你可以按类型筛选、按关键词查找，也能直接看热播榜和新番进度，不必在多个地址之间来回切换。',
  },
  {
    q: '“全集资源”和“更新中”有什么区别？',
    a: '“完结 / 全集”表示作品已经播完，可以按顺序一次看完，不用等更新；“更新中”表示仍在跟进播出，卡片上会标注当前更新到第几话。',
  },
  {
    q: '怎么快速判断一部作品适不适合自己？',
    a: '每张卡片都配了一句简介和一句“看点”。简介说明题材与主线，看点点出这部作品最突出的部分，比如分镜、美术、节奏或情绪落点，方便你几十秒内做出判断。',
  },
  {
    q: '类型筛选和搜索会改变页面内容吗？',
    a: '不会。筛选与搜索只作用于本页已经列出的作品，属于页内快速定位，不会跳转到新的页面，也不会改动其他分区的内容。',
  },
  {
    q: '为什么有的作品被放进“完结神作”？',
    a: '这一区收录的是篇幅相对完整、结局收束较好的完结作品。每部都附了一段较长的补充说明，讲清楚它适合什么样的观看节奏。',
  },
  {
    q: '收藏清单和榜单会经常变吗？',
    a: '榜单会随当期热度调整，新番区随季度更新，而“完结神作”相对稳定，属于可以长期留作待看列表的部分。本页展示的是本期的整理结果。',
  },
];

export const animeFootLinks = [
  {
    title: '热门分区',
    items: [
      { label: '本周热播榜', href: '#ranking' },
      { label: '作品速查库', href: '#library' },
      { label: '新番导视', href: '#season' },
      { label: '编辑精选', href: '#picks' },
    ],
  },
  {
    title: '深度内容',
    items: [
      { label: '完结神作', href: '#classics' },
      { label: '追番指南', href: '#guide' },
      { label: '漫迷问答', href: '#faq' },
      { label: '回到顶部', href: '#top' },
    ],
  },
  {
    title: '常用类型',
    items: [
      { label: '热血战斗', href: '#library' },
      { label: '科幻机甲', href: '#library' },
      { label: '奇幻冒险', href: '#library' },
      { label: '日常治愈', href: '#library' },
    ],
  },
];

export const heroStats = [
  { value: '14', label: '本期收录作品' },
  { value: '6', label: '内容类型分类' },
  { value: '6', label: '本周热播榜单' },
  { value: '4', label: '完结神作推荐' },
];